import { viewSchemas } from "@redotech/redo-model/views/views";
import * as z from "zod";

export const saveWorkOrderView = {
  name: "saveWorkOrderView" as const,
  input: z.object({ view: viewSchemas["work-orders"] }),
  output: z.object({}),
};
